import { useEffect, useState } from 'react'
import s from '../styles/ThinkingIndicator.module.scss'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrowLeft.svg'

/**
 * Animated "THOUGHT FOR Xs" indicator shown while the bot is thinking.
 * Matches the Figma "THOUGHT FOR 4s >" collapsible.
 */
export default function ThinkingIndicator({ isLoading }) {
	const [elapsed, setElapsed] = useState(0)

	useEffect(() => {
		if (!isLoading) {
			setElapsed(0)
			return
		}

		const start = Date.now()
		const interval = setInterval(() => {
			setElapsed(Math.floor((Date.now() - start) / 1000))
		}, 1000)

		return () => clearInterval(interval)
	}, [isLoading])

	if (!isLoading) return null

	return (
		<div className={s.wrap}>
			<div className={s.inner}>
				<span className={s.text}>THOUGHT FOR {elapsed}s</span>
				<span className={s.arrow}>
					<ArrowIcon />
				</span>
			</div>
			<div className={s.dots}>
				<span className={s.dot} />
				<span className={s.dot} />
				<span className={s.dot} />
			</div>
		</div>
	)
}
